
import { Ticket } from "@/models/ticket";
import { CompanyDossierService, TicketService } from "@/services";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			vatNumber: "",
			glnNumber: "",
			isSaving: false,
			sendOnly: false
		};
	},
	props: {
		dossierId: {
			type: Number,
			required: true
		},
		title: String,
		ticket: Ticket
	},
	computed: {
		isBelgianVat():boolean {
			return /^BE\d{10}$/.test(this.vatNumber);
		},
		isDutchVat():boolean {
			return /^NL\d{9}B\d{2}$/.test(this.vatNumber);
		},
		isSpanishVat():boolean {
			if(/^ES[ABCDEFGHJNPQRSUVW]\d{7}[0-9A-J]$/.test(this.vatNumber)) return true;
			if(/^ES\d{8}[A-Z]$/.test(this.vatNumber))return true;
			if(/^ES[XYZ]\d{7}[A-Z]$/.test(this.vatNumber))return true;
			return false;
		},
		isValidVat():boolean{
			if (this.isBelgianVat) return true;
			if (this.isDutchVat) return true;
			if (this.isSpanishVat) return true;
			return false;
		},
		isValid():boolean{
			return this.isValidVat || this.isValidGlnNumber;
		},
		isValidGlnNumber():boolean {
			return /^[0-9]{13}$/.test(this.glnNumber);
		},
		toUseTitle():string{
			if (this.title) return this.title;
			return "PEPPOL Endpoint toevoegen";
		}
	},
	watch: {
		vatNumber: {
			async handler(){
				if (/[a-z\s\.]/.test(this.vatNumber)){
					let vatNumber = this.vatNumber.toUpperCase().replaceAll(/\s/g, "").replaceAll(".", "");
					await Vue.nextTick();
					this.vatNumber = vatNumber;
				}
			}
		},
		glnNumber: {
			async handler(){
				if (/[^\d]/g.test(this.glnNumber)) {
					this.glnNumber = this.glnNumber.replaceAll(/[^\d]/g, "");
				}
			}
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async registerBelgianVat(){
			if (!this.isBelgianVat) return;
			let vatNumber = this.vatNumber.trim().toLowerCase().replaceAll(" ", "").replaceAll(".", "");
			let endpoint = `9925:${vatNumber}`;
			await CompanyDossierService.registerPeppolEndpoint(this.dossierId, endpoint, this.sendOnly);
			endpoint = `0208:${vatNumber.substring(2)}`;
			await CompanyDossierService.registerPeppolEndpoint(this.dossierId, endpoint, this.sendOnly);
		},
		async registerDutchVat(){
			if (!this.isDutchVat) return;
			let vatNumber = this.vatNumber.trim().toLowerCase().replaceAll(" ", "").replaceAll(".", "");
			let endpoint = `9944:${vatNumber}`;
			await CompanyDossierService.registerPeppolEndpoint(this.dossierId, endpoint, this.sendOnly);
		},
		async registerSpanishVat(){
			if (!this.isSpanishVat) return;
			let vatNumber = this.vatNumber.trim().toLowerCase().replaceAll(" ", "").replaceAll(".", "");
			let endpoint = `9920:${vatNumber}`;
			await CompanyDossierService.registerPeppolEndpoint(this.dossierId, endpoint, this.sendOnly);
		},
		async registerGln(){
			if (!this.isValidGlnNumber) return;
			let glnNumber = this.glnNumber.trim().toLowerCase().replaceAll(" ", "").replaceAll(".", "");
			let endpoint = `0088:${glnNumber}`;
			await CompanyDossierService.registerPeppolEndpoint(this.dossierId, endpoint, this.sendOnly);
		},
		async sendTicketResponse(){
			if (!this.ticket) return;
			await TicketService.sendResponse(this.ticket.id, {
				isInternal: false,
				isInterraction: false,
				content: "Goed nieuws: je bent nu helemaal aangesloten op Peppol via Winfakt!" +
					"\nVanaf nu kun je elektronische facturen rechtstreeks via het Peppol-netwerk verzenden en ontvangen.",
				attentions: [],
				attachements: [],
				notifyUser: true
			});
		},
		async confirm(){
			if (!this.isValid) return;
			this.isSaving = true;
			try{
				if (this.isBelgianVat){
					await this.registerBelgianVat();
				}else if (this.isDutchVat){
					await this.registerDutchVat();
				}else if (this.isSpanishVat){
					await this.registerSpanishVat();
				}else if (!this.isValidGlnNumber){
					throw new Error("How can this be valid if none of the formats match?");
				}
				if (this.isValidGlnNumber){
					await this.registerGln();
				}
				this.sendTicketResponse();
				this.$emit("saved");
				this.$emit("close");
			}catch(err){

			}finally{
				this.isSaving = false;
			}
		}
	}
});
